import { formatArcScore, formatCurrencyValue } from "../../utils/Helper";
export const REGION_COUNTRIES = {
    Africa: [
      "Algeria",
      "Egypt",
      "Libya",
      "Morocco",
      "Sudan",
      "Tunisia",
      "Western Sahara",
      "Burundi",
      "Comoros",
      "Djibouti",
      "Eritrea",
      "Ethiopia",
      "Kenya",
      "Madagascar",
      "Malawi",
      "Mauritius",
      "Mozambique",
      "Rwanda",
      "Seychelles",
      "Somalia",
      "South Sudan",
      "Tanzania",
      "Uganda",
      "Zambia",
      "Zimbabwe",
      "Angola",
      "Cameroon",
      "Central African Republic",
      "Chad",
      "Congo (Republic)",
      "Congo (Democratic Republic)",
      "Equatorial Guinea",
      "Gabon",
      "São Tomé and Príncipe",
      "Botswana",
      "Eswatini",
      "Lesotho",
      "Namibia",
      "South Africa",
      "Benin",
      "Burkina Faso",
      "Cape Verde",
      "Côte d'Ivoire",
      "Gambia",
      "Ghana",
      "Guinea",
      "Guinea-Bissau",
      "Liberia",
      "Mali",
      "Mauritania",
      "Niger",
      "Nigeria",
      "Senegal",
      "Sierra Leone",
      "Togo",
    ],
    Asia: [
      "Kazakhstan",
      "Kyrgyzstan",
      "Tajikistan",
      "Turkmenistan",
      "Uzbekistan",
      "China",
      "Japan",
      "Mongolia",
      "North Korea",
      "South Korea",
      "Taiwan",
      "Afghanistan",
      "Bangladesh",
      "Bhutan",
      "India",
      "Maldives",
      "Nepal",
      "Pakistan",
      "Sri Lanka",
      "Brunei",
      "Cambodia",
      "East Timor",
      "Indonesia",
      "Laos",
      "Malaysia",
      "Myanmar",
      "Philippines",
      "Singapore",
      "Thailand",
      "Vietnam",
    ],
    "Middle East": [
      "Armenia",
      "Azerbaijan",
      "Bahrain",
      "Cyprus",
      "Georgia",
      "Iran",
      "Iraq",
      "Israel",
      "Jordan",
      "Kuwait",
      "Lebanon",
      "Oman",
      "Palestine",
      "Qatar",
      "Saudi Arabia",
      "Syria",
      "Turkey",
      "UAE",
      "Yemen",
    ],
    Europe: [
      "Belarus",
      "Bulgaria",
      "Czechia",
      "Hungary",
      "Moldova",
      "Poland",
      "Romania",
      "Russia",
      "Slovakia",
      "Ukraine",
      "Denmark",
      "Estonia",
      "Finland",
      "Iceland",
      "Ireland",
      "Latvia",
      "Lithuania",
      "Norway",
      "Sweden",
      "United Kingdom",
      "Albania",
      "Andorra",
      "Bosnia and Herzegovina",
      "Croatia",
      "Greece",
      "Italy",
      "Kosovo",
      "Malta",
      "Montenegro",
      "North Macedonia",
      "Portugal",
      "San Marino",
      "Serbia",
      "Slovenia",
      "Spain",
      "Vatican City",
      "Austria",
      "Belgium",
      "France",
      "Germany",
      "Liechtenstein",
      "Luxembourg",
      "Monaco",
      "Netherlands",
      "Switzerland",
    ],
    "North America": ["Canada", "Mexico", "United States"],
    "Central America": [
      "Belize",
      "Costa Rica",
      "El Salvador",
      "Guatemala",
      "Honduras",
      "Nicaragua",
      "Panama",
    ],
    Caribbean: [
      "Antigua and Barbuda",
      "Bahamas",
      "Barbados",
      "Cuba",
      "Dominica",
      "Dominican Republic",
      "Grenada",
      "Haiti",
      "Jamaica",
      "Saint Kitts and Nevis",
      "Saint Lucia",
      "Saint Vincent and the Grenadines",
      "Trinidad and Tobago",
    ],
    "South America": [
      "Argentina",
      "Bolivia",
      "Brazil",
      "Chile",
      "Colombia",
      "Ecuador",
      "Guyana",
      "Paraguay",
      "Peru",
      "Suriname",
      "Uruguay",
      "Venezuela",
    ],
    "Australia and New Zealand": ["Australia", "New Zealand"],
    LATAM: [
      "Mexico",
      "Guatemala",
      "Honduras",
      "El Salvador",
      "Nicaragua",
      "Costa Rica",
      "Panama",
      "Cuba",
      "Dominican Republic",
      "Haiti",
      "Jamaica",
      "Puerto Rico",
      "The Bahamas",
      "Barbados",
      "Grenada",
      "Trinidad and Tobago",
      "Saint Lucia",
      "Saint Vincent and the Grenadines",
      "Colombia",
      "Venezuela",
      "Guyana",
      "Suriname",
      "Brazil",
      "Ecuador",
      "Peru",
      "Bolivia",
      "Chile",
      "Paraguay",
      "Argentina",
      "Uruguay",
    ],
  };
export const STRING_OPERATORS = {
  IS: "is",
  STARTS_WITH: "starts with",
  ENDS_WITH: "ends with",
  CONTAINS: "contains",
};

export const NUMBER_OPERATORS = {
  EQUALS: "=",
  GREATER_THAN: ">",
  LESS_THAN: "<",
  GREATER_THAN_EQUALS: ">=",
  LESS_THAN_EQUALS: "<=",
};

export const DATE_OPERATORS = {
  EQUALS: "=",
  BEFORE: "<",
  AFTER: ">",
  BEFORE_OR_ON: "<=",
  AFTER_OR_ON: ">=",
};

export const defaultFilters = {
  companyName: {
    value: "",
    operator: STRING_OPERATORS.CONTAINS,
  },
  requestedLimit: {
    value: "",
    operator: NUMBER_OPERATORS.EQUALS,
  },
  recommendedLimit: {
    value: "",
    operator: NUMBER_OPERATORS.EQUALS,
  },
  arcScore: {
    value: "",
    operator: NUMBER_OPERATORS.EQUALS,
  },
  rationale: {
    value: "",
    operator: STRING_OPERATORS.CONTAINS,
  },
  createdAt: {
    value: "",
    operator: DATE_OPERATORS.EQUALS,
  },
  paymentIndex: {
    value: "",
    operator: NUMBER_OPERATORS.EQUALS,
  },
  arInArrear: {
    value: "",
    operator: NUMBER_OPERATORS.EQUALS,
  },
  country: {
    value: "",
    operator: STRING_OPERATORS.IS,
  },
  countryScore: {
    value: "",
    operator: NUMBER_OPERATORS.EQUALS,
  },
  geographicalRegion: {
    value: "",
    operator: STRING_OPERATORS.IS,
  },
};

const getNumericalValue = (value) => {
  if (typeof value === 'number') return value;
  if (typeof value === 'string') {
    const num = parseFloat(value.replace(/[^0-9.-]+/g, ""));
    return isNaN(num) ? 0 : num;
  }
  return 0;
};

const calculateArInArrear = (summary) => {
  if (!summary) return 0;
  const arInArrear = summary["AR in Arrear"] || 0;
  return formatCurrencyValue(arInArrear);
};

const normalizeDate = (date) => {
  const d = new Date(date);
  // Reset time to midnight UTC
  return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
};

export const applyFilters = (companySummaryData, currentFilters) => {
  return companySummaryData.filter(summary => {
    const summaryData = summary?.summaryData || {};

    if (currentFilters.requestedLimit.value) {
      const requestedLimit = formatCurrencyValue(summaryData?.["Requested Limit"]);
      const filterValue = formatCurrencyValue(currentFilters.requestedLimit.value);

      switch (currentFilters.requestedLimit.operator) {
        case NUMBER_OPERATORS.EQUALS:
          if (requestedLimit !== filterValue) return false;
          break;
        case NUMBER_OPERATORS.GREATER_THAN:
          if (requestedLimit <= filterValue) return false;
          break;
        case NUMBER_OPERATORS.LESS_THAN:
          if (requestedLimit >= filterValue) return false;
          break;
        case NUMBER_OPERATORS.GREATER_THAN_EQUALS:
          if (requestedLimit < filterValue) return false;
          break;
        case NUMBER_OPERATORS.LESS_THAN_EQUALS:
          if (requestedLimit > filterValue) return false;
          break;
        default:
          break;
      }
    }

    if (currentFilters.arcScore.value) {
      const arcScore = getNumericalValue(summaryData?.["Combined Score"]);
      const filterValue = getNumericalValue(currentFilters.arcScore.value);

      if (isNaN(arcScore) || isNaN(filterValue)) return false;

      switch (currentFilters.arcScore.operator) {
        case NUMBER_OPERATORS.EQUALS:
          if (arcScore !== filterValue) return false;
          break;
        case NUMBER_OPERATORS.GREATER_THAN:
          if (arcScore <= filterValue) return false;
          break;
        case NUMBER_OPERATORS.LESS_THAN:
          if (arcScore >= filterValue) return false;
          break;
        case NUMBER_OPERATORS.GREATER_THAN_EQUALS:
          if (arcScore < filterValue) return false;
          break;
        case NUMBER_OPERATORS.LESS_THAN_EQUALS:
          if (arcScore > filterValue) return false;
          break;
        default:
      }
    }

    if (currentFilters.recommendedLimit.value) {
      const recommendedLimit = formatCurrencyValue(summaryData?.["Recommended Limit"]);
      const filterValue = formatCurrencyValue(currentFilters.recommendedLimit.value);

      switch (currentFilters.recommendedLimit.operator) {
        case NUMBER_OPERATORS.EQUALS:
          if (recommendedLimit !== filterValue) return false;
          break;
        case NUMBER_OPERATORS.GREATER_THAN:
          if (recommendedLimit <= filterValue) return false;
          break;
        case NUMBER_OPERATORS.LESS_THAN:
          if (recommendedLimit >= filterValue) return false;
          break;
        case NUMBER_OPERATORS.GREATER_THAN_EQUALS:
          if (recommendedLimit < filterValue) return false;
          break;
        case NUMBER_OPERATORS.LESS_THAN_EQUALS:
          if (recommendedLimit > filterValue) return false;
          break;
        default:
          break;
      }
    }

    if (currentFilters.arInArrear.value) {
      const arInArrear = calculateArInArrear(summaryData);
      const filterValue = formatCurrencyValue(currentFilters.arInArrear.value);

      switch (currentFilters.arInArrear.operator) {
        case NUMBER_OPERATORS.EQUALS:
          if (arInArrear !== filterValue) return false;
          break;
        case NUMBER_OPERATORS.GREATER_THAN:
          if (arInArrear <= filterValue) return false;
          break;
        case NUMBER_OPERATORS.LESS_THAN:
          if (arInArrear >= filterValue) return false;
          break;
        case NUMBER_OPERATORS.GREATER_THAN_EQUALS:
          if (arInArrear < filterValue) return false;
          break;
        case NUMBER_OPERATORS.LESS_THAN_EQUALS:
          if (arInArrear > filterValue) return false;
          break;
        default:
          break;
      }
    }

    if (currentFilters.companyName.value) {
      const companyName = summaryData?.["Company Name"]?.toLowerCase() || "";
      const nameFilterValue = currentFilters.companyName.value.toLowerCase();

      switch (currentFilters.companyName.operator) {
        case STRING_OPERATORS.IS:
          if (companyName !== nameFilterValue) return false;
          break;
        case STRING_OPERATORS.STARTS_WITH:
          if (!companyName.startsWith(nameFilterValue)) return false;
          break;
        case STRING_OPERATORS.ENDS_WITH:
          if (!companyName.endsWith(nameFilterValue)) return false;
          break;
        case STRING_OPERATORS.CONTAINS:
          if (!companyName.includes(nameFilterValue)) return false;
          break;
        default:
          break;
      }
    }

    if (currentFilters.rationale.value) {
      const rationale = summaryData?.["Underwriting Reason"]?.toLowerCase() || '';
      const rationaleFilterValue = currentFilters.rationale.value.toLowerCase();

      switch (currentFilters.rationale.operator) {
        case STRING_OPERATORS.IS:
          if (rationale !== rationaleFilterValue) return false;
          break;
        case STRING_OPERATORS.STARTS_WITH:
          if (!rationale.startsWith(rationaleFilterValue)) return false;
          break;
        case STRING_OPERATORS.ENDS_WITH:
          if (!rationale.endsWith(rationaleFilterValue)) return false;
          break;
        case STRING_OPERATORS.CONTAINS:
          if (!rationale.includes(rationaleFilterValue)) return false;
          break;
        default:
          break;
      }
    }

    if (currentFilters.createdAt.value) {
      const createdAt = normalizeDate(summary.createdAt);
      const dateFilterValue = normalizeDate(currentFilters.createdAt.value);

      switch (currentFilters.createdAt.operator) {
        case DATE_OPERATORS.EQUALS:
          if (createdAt !== dateFilterValue) return false;
          break;
        case DATE_OPERATORS.BEFORE:
          if (createdAt >= dateFilterValue) return false;
          break;
        case DATE_OPERATORS.AFTER:
          if (createdAt <= dateFilterValue) return false;
          break;
        case DATE_OPERATORS.BEFORE_OR_ON:
          if (createdAt > dateFilterValue) return false;
          break;
        case DATE_OPERATORS.AFTER_OR_ON:
          if (createdAt < dateFilterValue) return false;
          break;
        default:
          break;
      }
    }

    if (currentFilters.paymentIndex.value) {
      const paymentIndex = formatCurrencyValue(summaryData?.["paydex"]);
      const filterValue = formatCurrencyValue(currentFilters.paymentIndex.value);

      switch (currentFilters.paymentIndex.operator) {
        case NUMBER_OPERATORS.EQUALS:
          if (paymentIndex !== filterValue) return false;
          break;
        case NUMBER_OPERATORS.GREATER_THAN:
          if (paymentIndex <= filterValue) return false;
          break;
        case NUMBER_OPERATORS.LESS_THAN:
          if (paymentIndex >= filterValue) return false;
          break;
        case NUMBER_OPERATORS.GREATER_THAN_EQUALS:
          if (paymentIndex < filterValue) return false;
          break;
        case NUMBER_OPERATORS.LESS_THAN_EQUALS:
          if (paymentIndex > filterValue) return false;
          break;
        default:
          break;
      }
    }

    if (currentFilters.country && currentFilters.country.value) {
      const countryField = summary?.["country"];
      if (!countryField) return false;
      const countryStr = String(countryField);
      const country = countryStr.includes(',')
        ? countryStr.split(',').pop().trim().toLowerCase()
        : countryStr.trim().toLowerCase();
      const filterValue = currentFilters.country.value.trim().toLowerCase();

      switch (currentFilters.country.operator) {
        case STRING_OPERATORS.IS:
          if (country !== filterValue) return false;
          break;
        case STRING_OPERATORS.IS_NOT:
          if (country === filterValue) return false;
          break;
        case STRING_OPERATORS.CONTAINS:
          if (!country.includes(filterValue)) return false;
          break;
        case STRING_OPERATORS.DOES_NOT_CONTAIN:
          if (country.includes(filterValue)) return false;
          break;
        case STRING_OPERATORS.STARTS_WITH:
          if (!country.startsWith(filterValue)) return false;
          break;
        case STRING_OPERATORS.ENDS_WITH:
          if (!country.endsWith(filterValue)) return false;
          break;
        default:
          break;
      }
    }

    // Country Score filter (numerical, with operators)
    if (currentFilters.countryScore && currentFilters.countryScore.value) {
      const countryScore = getNumericalValue(summaryData?.["Country Score"]);
      const filterValue = getNumericalValue(currentFilters.countryScore.value);
      if (isNaN(countryScore) || isNaN(filterValue)) return false;
      switch (currentFilters.countryScore.operator) {
        case NUMBER_OPERATORS.EQUALS:
          if (countryScore !== filterValue) return false;
          break;
        case NUMBER_OPERATORS.GREATER_THAN:
          if (countryScore <= filterValue) return false;
          break;
        case NUMBER_OPERATORS.LESS_THAN:
          if (countryScore >= filterValue) return false;
          break;
        case NUMBER_OPERATORS.GREATER_THAN_EQUALS:
          if (countryScore < filterValue) return false;
          break;
        case NUMBER_OPERATORS.LESS_THAN_EQUALS:
          if (countryScore > filterValue) return false;
          break;
        default:
          break;
      }
    }

    // Region filter (geographicalRegion)
    if (currentFilters.geographicalRegion && currentFilters.geographicalRegion.value) {
      const selectedRegion = currentFilters.geographicalRegion.value;
      const validCountries = REGION_COUNTRIES[selectedRegion] || [];
      const countryField = summary?.["country"];
      if (!countryField) return false;
      const countryStr = String(countryField);
      const country = countryStr.includes(',')
        ? countryStr.split(',').pop().trim().toLowerCase()
        : countryStr.trim().toLowerCase();
      const isCountryInRegion = validCountries.some(
        validCountry => validCountry.toLowerCase() === country
      );
      if (!isCountryInRegion) return false;
    }

    return true;
  });
}; 